import React, { useEffect, useState } from 'react';

import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import Button from 'components/lib/Button';
import Input from 'components/lib/Input';
import { useDebounce } from 'utils/hooks/useDebounce';

import { useShopperEmailsContext } from './ShopperEmailsContext';
import ShopperEmailsFilters from './ShopperEmailsFilters';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 30px;
`;

const ControlsInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const SearchInput = styled(Input)`
  width: 500px;
`;

const ShopperEmailsControls = () => {
  const { filters, setFilters, openCreateModal } = useShopperEmailsContext();
  const [search, setSearch] = useState(filters.search);
  const debouncedSearch = useDebounce(search, 300);

  useEffect(() => {
    setSearch(filters.search);
  }, [filters.search]);

  useEffect(() => {
    setFilters({ search: debouncedSearch });
  }, [debouncedSearch, setFilters]);

  return (
    <Container>
      <ControlsInfo>
        <SearchInput
          value={search}
          prefix={<SearchOutlined />}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => setSearch(event.target.value)}
          placeholder="Search shopper contacts"
        />
        <ShopperEmailsFilters />
      </ControlsInfo>
      <Button type="primary" icon={<PlusOutlined />} onClick={openCreateModal}>
        Add Shopper Contact
      </Button>
    </Container>
  );
};

export default ShopperEmailsControls;
